import { createFileRoute } from '@tanstack/react-router';

import { potentialGuestsListSearchSchema } from '../-shared/potentialGuestsListSearchSchema';

export const Route = createFileRoute('/_private/_route/_internal/events/new/')({
  validateSearch: potentialGuestsListSearchSchema,
});
